var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon12BlogCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.67 0 10 3.53 10 3.53v16.05c0 .23-.19.42-.43.42H2.43a.43.43 0 0 1-.43-.43V5.54S6.33 2 12 2m0-2C5.69 0 .94 3.81.74 3.98A2 2 0 0 0 0 5.53v16.05A2.43 2.43 0 0 0 2.42 24h19.15A2.43 2.43 0 0 0 24 21.57V5.54a2 2 0 0 0-.74-1.55C23.06 3.8 18.31 0 12 0z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 16.38V22M7.03 11.99h9.94M7.03 7.21h9.94"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTEyIDJjNS42NyAwIDEwIDMuNTMgMTAgMy41M3YxNi4wNWMwIC4yMy0uMTkuNDItLjQzLjQySDIuNDNhLjQzLjQzIDAgMCAxLS40My0uNDNWNS41NFM2LjMzIDIgMTIgMm0wLTJDNS42OSAwIC45NCAzLjgxLjc0IDMuOThBMiAyIDAgMCAwIDAgNS41M3YxNi4wNUEyLjQzIDIuNDMgMCAwIDAgMi40MiAyNGgxOS4xNUEyLjQzIDIuNDMgMCAwIDAgMjQgMjEuNTdWNS41NGEyIDIgMCAwIDAtLjc0LTEuNTVDMjMuMDYgMy44IDE4LjMxIDAgMTIgMHoiIGZpbGw9IiMwMDAiIC8+DQogICAgPHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTEyIDE2LjM4VjIyTTcuMDMgMTEuOTloOS45NE03LjAzIDcuMjFoOS45NCIvPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgIcon12BlogCompany as ReactComponent };